if (!customElements.get('download-toggle')) {
  class DownloadToggle extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(
        new CustomEvent('exo:toggle-download-popup', {
          detail: { id: this.getAttribute('data-id') },
        }),
      );
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('download-toggle', DownloadToggle);
}
